import React from 'react'
import { formatEventTime } from './EventCalendarEditor'
import { tenis10CategoryLabel } from './tenis10Event'

// The event date history (glossary „Istoricul datelor unui eveniment”): every change of the event's dates, newest first, as the API keeps
// it from the save that made it (sportya-api Events/features/eventEditing/dateHistory.js).
const SOURCES = { eventPage: 'Event page', eventsPlanner: 'Events Planner' }
// The event's own dates the history keeps, by the field an entry names them with: how the page labels each, and where a draft holds it.
// Competition starts are kept too; the details save never moves one, and the competition editor keeps its own.
const DATES = {
  startDate: { label: 'Starts', read: details => details.startDate },
  endDate: { label: 'Ends', read: details => details.endDate },
  preRegistrationsOpen: { label: 'Pre-registration opens', read: details => details.phases?.preRegistrationsOpen?.startDate },
  registrationsOpen: { label: 'Registrations open', read: details => details.phases?.registrationsOpen?.startDate },
}
const gameTypeLabel = value => value ? value.charAt(0).toUpperCase() + value.slice(1) : 'Competition'
// An entry names a competition by its adult level: a Tenis10 one of the event's competitions reads by its category, „Verde · U10”.
const competitionLevel = (competition, competitions = []) => {
  const current = competitions.find(item => item?._id === competition?.id)
  return current?.tenis10Level ? tenis10CategoryLabel(current) : `Level ${competition?.level ?? '—'}`
}
const dateLabel = ({ field, competition }, competitions) => field === 'competitionStart'
  ? `${gameTypeLabel(competition?.gameType)} · ${competitionLevel(competition, competitions)} starts` : DATES[field]?.label || field
const author = actor => [actor?.firstName, actor?.lastName].filter(Boolean).join(' ') || 'Unknown author'

const instant = value => {
  const time = value == null ? NaN : new Date(value).getTime()
  return Number.isFinite(time) ? time : null
}
// Whether `current` changes one of the event's own dates the history keeps from `previous`, compared as instants, as the API decides it.
export const changesTrackedDates = (previous, current) => Object.values(DATES).some(({ read }) => instant(read(previous)) !== instant(read(current)))

// An empty list is the API's answer for an event whose dates have not changed since the history exists, so it says so.
export default function EventDateHistory({ entries, timezone, competitions }) {
  return <div className="event-date-history"><h4 id="event-date-history">Date changes</h4>
    {entries.length ? <ol aria-labelledby="event-date-history">{entries.map(entry => <li key={entry.id}>
      <p><strong>{`${formatEventTime(entry.at, timezone)} · ${author(entry.actor)} · ${SOURCES[entry.source] || entry.source}`}</strong></p>
      {entry.changes.map(change => <p key={change.field + (change.competition?.id || '')}>
        {`${dateLabel(change, competitions)}: ${formatEventTime(change.from, timezone)} → ${formatEventTime(change.to, timezone)}`}</p>)}
      {entry.note && <p className="text-muted">{'Note: ' + entry.note}</p>}
    </li>)}</ol>
      : <p className="text-muted">No date changes recorded. Changes saved before this history existed are not listed.</p>}
  </div>
}
